import { Text, Badge, Group, Title, Table, ActionIcon, Tooltip } from '@mantine/core';
import { ViewPanel } from '@ayocore/platform/client/components/EntityViewLayout';
import { IconTarget, IconEye } from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import type { Lead } from '../../../../../schemas/lead.schema';

interface PartnerLeadsProps {
  leads: Lead[];
}

export function PartnerLeads({ leads }: PartnerLeadsProps) {
  const navigate = useNavigate();

  return (
    <ViewPanel>
      <Group justify='space-between' align='center' mb='xs'>
        <Title order={4} style={{ fontSize: 14, fontWeight: 400 }}>
          <Group gap='sm'>
            <IconTarget size={16} />
            Связанные лиды ({leads.length})
          </Group>
        </Title>
      </Group>

      {leads.length > 0 ? (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>
                <Text size='xs'>Название</Text>
              </Table.Th>
              <Table.Th>
                <Text size='xs'>Сумма</Text>
              </Table.Th>
              <Table.Th>
                <Text size='xs'>Вероятность</Text>
              </Table.Th>
              <Table.Th>
                <Text size='xs'>Ожидаемое закрытие</Text>
              </Table.Th>
              <Table.Th>
                <Text size='xs'>Действия</Text>
              </Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {leads.map(lead => (
              <Table.Tr key={lead.id}>
                <Table.Td>
                  <Text
                    fw={500}
                    size='xs'
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() => navigate(`/crm/leads/${lead.id}`)}
                  >
                    {lead.title}
                  </Text>
                  {lead.description && (
                    <Text size='xs' c='dimmed' lineClamp={1}>
                      {lead.description}
                    </Text>
                  )}
                </Table.Td>
                <Table.Td>
                  <Text size='xs'>
                    {lead.amount
                      ? `${lead.amount.toLocaleString()} ${lead.currency || 'RUB'}`
                      : '—'}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Badge
                    color={
                      lead.probability >= 80 ? 'green' : lead.probability >= 50 ? 'yellow' : 'red'
                    }
                    variant='light'
                    size='xs'
                  >
                    {lead.probability}%
                  </Badge>
                </Table.Td>
                <Table.Td>
                  <Text size='xs'>
                    {lead.expected_close_date
                      ? new Date(lead.expected_close_date).toLocaleDateString()
                      : '—'}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Tooltip label='Просмотр лида'>
                    <ActionIcon
                      variant='light'
                      size='xs'
                      onClick={() => navigate(`/crm/leads/${lead.id}`)}
                      style={{ cursor: 'pointer' }}
                    >
                      <IconEye size={14} />
                    </ActionIcon>
                  </Tooltip>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      ) : (
        <Text c='dimmed' ta='center' py='xs' size='xs'>
          Лиды для данного партнера не найдены
        </Text>
      )}
    </ViewPanel>
  );
}
